var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPayments = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 9.99967C1.66797 6.85717 1.66797 5.28551 2.64464 4.30967C3.6213 3.33384 5.19213 3.33301 8.33463 3.33301H11.668C14.8105 3.33301 16.3821 3.33301 17.358 4.30967C18.3338 5.28634 18.3346 6.85717 18.3346 9.99967C18.3346 13.1422 18.3346 14.7138 17.358 15.6897C16.3813 16.6655 14.8105 16.6663 11.668 16.6663H8.33463C5.19213 16.6663 3.62047 16.6663 2.64464 15.6897C1.6688 14.713 1.66797 13.1422 1.66797 9.99967Z",
    stroke: "#3B4857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.33463 13.333H5.0013M11.668 13.333H10.418M1.66797 8.33301H18.3346",
    stroke: "#3B4857",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPayments, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/payments.3e753a40.svg";
export { ForwardRef as ReactComponent };